module.exports = __webpack_public_path__ + "img/music-dashboard.813b3271.svg";